/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});


	$(document).ready(function() {	
		miami.init();
	});

	var miami = {
        miamiTimeout: null,
		isSidebarAjaxClick: false,
		init: function() {	
          	this.header();
          	//this.slider();
            this.tabify();
          	this.qty();
          	
            
          	this.getSearchData();
            
          	this.wishlist();
            this.newsletter();
			this.widthResizeContent();
          	this.fancybox_popup();
          	this.quickview_popup();
            this.responsive_menu();
          	this.window_resize();
          	this.resizeContent();  
			//this.alert_css(); 
            this.pre_loader();
            this.scrolltop();
			this.section_script();
		},
      
        section_script: function(){
          var sections = new theme.Sections();
          sections.register('slideshow-section', miami.slider);
          sections.register('product-template', miami.product);
          sections.register('collection-template', miami.collection);
          sections.register('contact-map',miami.map);
        },
        
     map: function(container){
       var $container = this.$container = $(container);  
       var zoom_level = $container.attr('data-zoom_level');
       var scrollwheel = $container.attr('data-scrollwheel');
      
       if(scrollwheel == 'false'){
       	
         var boolen_scroll = 0 ;
         
       }else{
       	 
         var boolen_scroll = 1 ;
         
       }
       
         var latlng = new google.maps.LatLng(0, 0);
         var myOptions = {
           zoom: parseInt(zoom_level),
           center: latlng,
           scrollwheel:boolen_scroll,
           scaleControl:boolen_scroll,
           disableDefaultUI: false,
           mapTypeId: google.maps.MapTypeId.ROADMAP
         };
         var map2 = new google.maps.Map(document.getElementById("map-canvas"), myOptions);

         var geocoder_map2 = new google.maps.Geocoder();
         var address =$container.attr('data-address');
         geocoder_map2.geocode( { 'address': address}, function(results, status) {
           if (status == google.maps.GeocoderStatus.OK) {
             map2.setCenter(results[0].geometry.location);

             var marker = new google.maps.Marker({
               map: map2, 
               position: map2.getCenter()
             });

             var contentString = $container.attr('data-address');
             var infowindow = new google.maps.InfoWindow({
               content: contentString
             });



           } else {
             alert("Geocode was not successful for the following reason: " + status);
           }
         });
       
      },
      
      
        pre_loader : function(){

          $(window).on('load', function() { // makes sure the whole site is loaded 
            $('#status').fadeOut(); // will first fade out the loading animation 
            $('#preloader').delay(350).fadeOut('slow'); // will fade out the white DIV that covers the website. 
            $('body').delay(350).css({'overflow':'visible'});
            if($(window).width > 1024){
              new WOW().init();
            }
          }) 

        },
      
      	product: function(container){
          var $container = this.$container = $(container);
          var sectionId = $container.attr('data-section-id');
          
          if (!$('#ProductJson-' + sectionId).html()) {
            return;
          }
          var productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
       
         new Shopify.OptionSelectors('productSelect', {
         product: productSingleObject,
         onVariantSelected: selectCallback,
         enableHistoryState: true
       });

       var option_name = productSingleObject.options[0];


       // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
       if (productSingleObject.options.length == 1 && productSingleObject.options[0] != 'Title') {
         $('.selector-wrapper:eq(0)').prepend('<label for="productSelect-option-0">'+ option_name +'</label>');
       }

       // Hide selectors if we only have 1 variant and its title contains 'Default'.
       if (productSingleObject.variants.length == 1 && productSingleObject.variants[0].title.toLowerCase().indexOf('default') !== -1) {
         $('.selector-wrapper').hide();
       }

       jQuery(function() {
         jQuery('.swatch :radio').click(function() {
           var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
           $(this).parent().addClass("active");

           $(this).parent().siblings().removeClass('active');

           var main_iamge = $(this).parent().data('image');
           $('#ProductPhotoImg').attr('src',main_iamge);
           $('.zoomImg').attr('src',main_iamge);

           var optionValue = jQuery(this).val();
           jQuery(this)
           .closest('form')
           .find('.single-option-selector')
           .eq(optionIndex)
           .val(optionValue)
           .trigger('change');
         });
       });
          
       $('.swatch').each(function() {
         var index = $(this).data('option-index');
         $('.selector-wrapper:eq('+index+')').hide();
       });
          
          
          
          $("#AddToCart").click(function(e){
            var form = $(this).closest('form');
            miami.quickviewAjaxAddToCart(form);
            e.preventDefault();
          });
            

          miami.product_thumb_slider();
          if($container.attr('data-tab') == 'true'){
            $( "#pro-desc-tab" ).tabs();
          }
          
          
          
            
            var window_width = $( window ).width();
            if(window_width > 1024){  
              $("#ProductPhotoImg").elevateZoom({zoomType: "inner",cursor: "crosshair",divId: "zoomDivPro"});          
            }
           
          
          miami.grid_height();

      	},
      
        collection:function(){
           	miami.col_filter();
            miami.sort_filter();
            miami.collectionSidebar();   
            miami.grid_height();
            $(".sortby").heapbox();
          miami.widthResizeContent();
          
        },
      
        header: function() {          
          	 
            // =========== FOR STICKY NAV
            $(window).scroll(function() {
              var windowpos = $(window).scrollTop();
              if (windowpos > 20) {
                $('header').addClass('sticky');
              } else {
                $('header').removeClass('sticky')
              }
            }); 	
          
            //==================== Scroll For SEARCH POPUP
            $('.top_search').click(function(e) {
              $('.search_overlay').addClass('pop_class');

              if ($('.search_overlay').hasClass('pop_class'))
              {
                $('body').addClass('body_scroll');	
              }
            });


            $('.close').click(function(e) {             
              $('.overlay').removeClass('pop_class');
              $('body').removeClass('body_scroll');	
              $("#data_search").val("");
              $("#search-content .container").empty();
              $(".search_rult").empty().html("Search Product Result Goes here........");
            });		


            //==================== CART icon click
          	var window_width = $( window ).width();
          	if(window_width > 1024){
            $('.cart_top').click(function(e) {
              e.preventDefault();
              $('#CartDrawer').slideToggle(500);
            });
            }

            $('html').click(function() {
              $('#CartDrawer').slideUp();              
            });

            $('.cart_top,#CartDrawer').click(function(event){
              event.stopPropagation();
            });
          
          	//==================================   MENU TOGGLE  
            $(".menu-toggle ").click(function(e) {
                $('#main-nav').toggleClass('menu_slide');
                $('.button-nav').toggleClass('active');
                $('body').toggleClass('hidden');
            });

            //==================================   Menu Background
            var get_img = $('#main-nav > ul > li.active').data('src');
            if(get_img){
              $('#main-nav').css('background','#fff url('+ get_img +') no-repeat center');
            }
            else{
              $('#main-nav').css('background','#fff url(//cdn.shopify.com/s/files/1/2073/8565/t/2/assets/menu_1.jpg?5) no-repeat center');
            }


            $('#main-nav > ul > li').each(function(index, element) {
                $(this).hover(
                  function() {
                    var get_img =$(this).data('src');
                    $('#main-nav').css('background','#fff url('+ get_img +') no-repeat center');
                  }, function() {
                    var get_img = $('#main-nav ul li.active').data('src');
                    if(get_img){
                      $('#main-nav').css('background','#fff url('+ get_img +') no-repeat center');
                    }
                    else{
                      //$('#main-nav').css('background','#fff url(//cdn.shopify.com/s/files/1/2073/8565/t/2/assets/menu_1.jpg?5) no-repeat center');
                    }
                  }
                );
            }); 
          
            $('#main-nav  ul .sub_nav > a').click(function(e) {
              e.preventDefault();

              
                if($(this).parent().hasClass('open_nav')){
                  $(this).parent().removeClass('open_nav');
                }
                else{
                  $(this).parent().siblings().removeClass('open_nav');
                  $(this).parent().addClass('open_nav');
                }
              
            });         
          
        },
      
        slider: function(container) {
          var $container = this.$container = $(container);
    	  var id = $container.attr('data-section-id');
          var transition = $container.attr('data-transition');
          if($container.attr('data-autoplay') == 'true'){
            var autoplay = true;
          }
          else{
            var autoplay = false;
          }
            
          var speed = $container.attr('data-speed');
          
          if($container.attr('data-show-dots') == 'true'){
            var show_dots = true;
          }
          else{
            var show_dots = false;
          }
          if($container.attr('data-show-nav') == 'true'){
            var show_nav = true;
          }
          else{
            var show_nav = false;
          }
          
          if(transition == 'horizontal'){
          	var Loop_new = false;
		  }
          else{
          	var Loop_new = true;
          }
          //=============== SLIDER    =======          
          $('#banner_slider .bxslider_'+ id).bxSlider({
            mode: $container.attr('data-transition'),
            captions: true,
            auto:autoplay,
            controls: show_nav,
            pager: show_dots,
            pause: $container.attr('data-speed'),
            infiniteLoop: Loop_new
          });
			
          	
		},
		
		product_thumb_slider: function(){
			//  PRODUCT THUMB SLIDER
			var width_screen = $(window).width();
			if((width_screen < '991') && (width_screen >= '768')){ 
				var get_slider = $('#thumbs').clone();
				$('.thumb_slider').html(get_slider);
				$('#thumbs').bxSlider({
				  minSlides: 6,
				  maxSlides: 8,
				  slideWidth:100,
				  slideMargin:8,
				  pager:false,
				  controls:true,
				 mode: 'vertical'
				});
			}
			else{
				var get_slider = $('#thumbs').clone();
				$('.thumb_slider').html(get_slider);
				$('#thumbs').bxSlider({
				  minSlides: 4,
				  maxSlides: 8,
				  slideWidth:100,
				  slideMargin:16,
				  pager:false,
				  controls:true,
				  mode: 'horizontal'
				});
			}
          
          	miami.pro_thumb();
          
		},
      
        tabify: function() {
          // =============== PRODUCT DETAILS TABIFY
          
          $( "#tabs-features").tabs();
          
          $("#accord").accordion({
            collapsible: true,
            heightStyle: "content"
          });
        },
      	
      	widthResizeContent: function() {
            width_screen = $(window).width();          
            if(width_screen < "991"){  
              $( "#mobile_filter" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
              $( "#mobile_filter li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
              $("#mobile_filter .grid__item ul").removeClass("sidebar-tag");            
            }else{              
              $( "#mobile_filter" ).tabs();
              $('#mobile_filter').tabs('destroy');
              $("#mobile_filter .grid__item ul").addClass("sidebar-tag"); 
            }
        },
      
      	col_filter: function() {
          	//======================== FILTER - OPTION
            $('.filter-icon').click(function(e) {
              if($('.product-filter').css('display') == 'none')
              {
				$(".heapBox").hide();
                $(".filter-icon").addClass("active");
                $(".filter-options").addClass("active");
                $("body").addClass("filter_overflow");
              }
              else{
                $(".heapBox").show();
                $(".filter-icon").removeClass("active");
                $(".filter-options").removeClass("active");
                $("body").removeClass("filter_overflow");
              }
              
              $('.product-filter').slideToggle(200);              
            });
          	$('html').click(function() {
              $('.product-filter').slideUp(200);               
              $(".filter-icon").removeClass("active");
              $(".filter-options").removeClass("active");
              $(".heapBox").show();
            });
          	$('.filter-icon,.product-filter,.tag_list,.filter-options.active').click(function(event){
              event.stopPropagation();
            });
        },
      
      	product_list_slider:function() {
            //==================  RELATED - PRODUCT LIST
          var window_width = $( window ).width();
  			if(window_width <= 1024){
              $('#related_product .product_list .grid, #best_seller .product_list .grid').owlCarousel({
                  loop:false,
                  nav:false,
                  dots:false,
                  responsive:{
                      0:{
                        items:1,
                        dots:true,
                        //autoHeight:true
                      },
                      480:{
                        items:2,
                        dots:true,
                        margin:12,
                        //autoHeight:true
                      },
                      540:{
                        items:3,
                        dots:true,
                        margin:12,
                        //autoHeight:true
                      },
                      768:{
                        items:4,
                        margin:20,
                      },
                      991:{
                        items:4,
                        margin:25,
                      },
                      1024:{
                        items:4,
                        margin:30,
                      }     
                  }
              });
            }
          
        },
      
      	pro_thumb:function() {
         
          $("#thumbs a img").click(function(){
            var src_img = $(this).parent().data("img");
            $("#ProductPhotoImg").attr("src",src_img);
            
            
            var window_width = $( window ).width();
  			if(window_width > 1024){
              $('.zoomWindow').css('background-image','url('+ src_img +')');
            }
            
          });
         
        },
      
        qty:function(){
          	$("body").on('click', '.plus', function() {
                var getval = $(this).prev().val();
				getval++;
				$(this).prev().val(getval);
				$("#update-cart").trigger('click');
            });
          
          	$("body").on('click', '.minus', function() {
                var getval = $(this).prev().prev().val();
				if(getval > 1){
					getval--;
					$(this).prev().prev().val(getval);
					$("#update-cart").trigger('click');
				}
            });			
        },
      	
      	grid_height: function(){	
           //============================== PRODUCT LIST IMG HEIGHT     
           $('.product_list .product_item .product_img').responsiveEqualHeightGrid();      
		}, 
      
        getSearchData: function(){
			$("#data_search").keyup(function(e) {                	
                var postData = $("#search_form").serializeArray();
                var formURL = $("#search_form").attr("action");

                $.ajax({
                  url : formURL,
                  type: "POST",
                  data : postData,
                  beforeSend: function() {
                      miami.showLoading();
                  },
                  success:function(data, textStatus) {                    
                    miami.searchMapData(data);
                    setTimeout(function() {                      
                  		miami.grid_height();
                    }, 1000);
                    miami.hideLoading();                    
                  },
                  error: function() {
                    $(this).append("<p>I'm afraid that didn't work.</p>");
                  }
                });
            });
        },
      
        searchMapData:function(data){
          	$(".popup_search .search_rult").empty().html($(data).find(".search_reslt").text());
          
			if ($(data).find("#pro_listing").length > 0) {
              $("#search-content .container").empty().append($(data).find("#pro_listing"));
            }
            else{
			  $("#search-content .product_list").empty().html("Sorry!.... There are no results that match your search.");
            }
        },
      
  		sort_filter:function(){
          //--------------------------- FILTER COMBO SELECTED ITM
          
          var sort_title = $("#drop-dn .dropdownul li.selected").text();
          if(sort_title){
            $("#drop-dn span").text(sort_title);
          }

          //========================= FILTER VARIANT
          $('#drop-dn').click(function(e) {
            $('#drop-dn').toggleClass('active');
            return (false);
          });

        },
      
      	alert_css: function(){
          //------ alert css -----------
			window.alert = function(message) { $('#messageBox').text(message).fadeIn().delay(4000).fadeOut('slow'); }
        },
      	
        fancybox_popup: function(){
          $('.product-modal').fancybox({
          	afterLoad: function() {
              setTimeout(function(){
                $.fancybox.update();
              },50);
            }
          });
        },
      
        quickview_popup: function(){
              var get_slider = $('#thumbs-quickview').clone();
              $('.thumb_slider.quickview').html(get_slider);
              $('#thumbs-quickview').bxSlider({
                minSlides: 5,
                maxSlides: 6,
                slideWidth:92,
                slideMargin:5,
                pager:false,
                controls:true,
                mode: 'vertical'
              });
          
          $("#thumbs-quickview a img").click(function(){
              var src_img = $(this).parent().data("img");
              $(".quick_product_view #ProductPhotoImg").attr("src",src_img);

              
              var window_width = $( window ).width();
              if(window_width > 1024){
                  $('#zoomDivProQuick .zoomWindow').css('background-image','url('+ src_img +')');
              }
              
            });

            //wishlist
            miami.wishlist();

            //ajax
            
             $(".quick_view_add").click(function(e){
               	var form = $(this).closest('form');
          		miami.quickviewAjaxAddToCart(form);
               	e.preventDefault();
             });
            
          
  			 //zoom on featured image  
              
               var window_width = $( window ).width();
              if(window_width > 1024){  
                $(".quick_product_view #ProductPhotoImg").elevateZoom({zoomType: "inner",cursor: "crosshair",divId: "zoomDivProQuick"});
              }
             
          
          	miami.wishlist();
          
        },
      
      	quickviewAjaxAddToCart:function(form){
          	 $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: jQuery(form).serialize(),
                dataType: 'json',
               	beforeSend: function() {
                  $(form).find("#AddToCart").val("Wait..");
                },
                success: function(msg) { 
                  	$(form).find("#AddToCart").val("Added!!");
        
                    window.setTimeout(function() {
                      $(form).find("#AddToCart").val("Add to Cart");
                    }, 3000);
                 	miami.quickviewUpdateCart();
                },
                error: function(xhr, text) {
                    $(form).find("#AddToCart").val("Add to Cart");
                  	var data = eval('(' + xhr.responseText + ')');
                  	$('.quick_product_view #AddToCartForm').next().after('<div class="errors qty-error">'+ data.description +'</div>');
                   
                      $('#product_details .product_info #AddToCartForm').next().after('<div class="errors qty-error">'+ data.description +'</div>');
                  
                      window.setTimeout(function() {
                      $(".errors.qty-error").fadeOut();
                    }, 2000);
                }
            });
        },
      
      	quickviewUpdateCart:function(){
          	jQuery.getJSON('/cart.js', function (cart, textStatus) {
                $("#CartCount").show(); 
              	$("#CartCount").html("( "+cart.item_count+" )").removeClass('hidden-count');
            });          	
        },
      
      	collectionSidebar:function(){
        	miami.sidebarParams();            
            miami.sidebarMapEvents();
            if ($(".product-filter").length > 0) {
              miami.getCurrentTag();                     	
              miami.sidebarMapClear();
              miami.sidebarMapClearAll();
            }
            miami.sidebarMapPaging(); 
        },

      	responsive_menu:function(){
          	//================ RESPONSIVE MENU TRIGGER 
            jQuery('nav').meanmenu();
           
          
           var width_screen = $(window).width();
			if((width_screen < '768')){                            
               var get_menu = $('.snd-nav li:first').html();
               $('.mean-nav > ul').append('<li>'+ get_menu +'</li>');
            }
          
            $("a.meanmenu-reveal").click(function(){ 
              $('body').toggleClass("main_overflow");
             });

             $(".index_nav.mean-container a.meanmenu-reveal").click(function(){
               $('#header').toggleClass("white_bg");
             }); 
        },
      
        window_resize:function(){
          	//==========================  RESIZE HEIGHT			
            $(window).load(function(){
              miami.resizeContent();  
              miami.product_thumb_slider();
              miami.product_list_slider(); 
			});
            $(window).resize(function() {
              miami.resizeContent();
              miami.widthResizeContent(); 
              miami.product_thumb_slider();
              miami.product_list_slider();
              miami.grid_height();
            });
            $(window).on("orientationchange",function(){
              miami.collectionSidebar();
              miami.product_thumb_slider();
              miami.product_list_slider();
              miami.grid_height();
            });
        },
      
      	resizeContent: function(){
            height_screen = $(window).height();			
            $('#banner_slider .bx-viewport, #banner_slider .bx-viewport li').height(height_screen);			
            $('.page_content_404').height(height_screen);
            var header_heaight = $('#header').height();
            $('.empty_header').css("height" , header_heaight);

            menu_height = height_screen - 55;
            $('.mean-container .mean-bar .mean-nav').css({"overflow-y": "scroll", "max-height": menu_height});
        },
      
        sidebarParams: function() {
            Shopify.queryParams = {};
            //get after ?...=> Object {q: "Acme"} 
            if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
        },

        sidebarMapTagEvents: function() { 
            $('.sidebar-tag a:not(".clear"), .sidebar-tag li').click(function(e) {
                var currentTags = [];
                var check_radio =  $(this).find("input").attr("type");
                if (Shopify.queryParams.constraint) {
                    currentTags = Shopify.queryParams.constraint.split('+');
                }
                if(check_radio == "radio"){                 
                //one selection or multi selection                
                    if (!window.enable_sidebar_multiple_choice && !$(this).find("input").is(":checked")) {
                        //remove other selection first
                        var otherTag = $(this).parents('.sidebar-tag').find("input:checked");
                        if (otherTag.length > 0) {
                            var tagName = otherTag.val();
                            if (tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        }
                    }
                }

                var tagName = $(this).find("input").val();                
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);                    
                    if (tagPos >= 0) {
                        //tag already existed, remove tag
                        currentTags.splice(tagPos, 1);
                    } else {
                        //tag not existed
                        currentTags.push(tagName);
                    }
                }
              
                if (currentTags.length) {
                    $(".filter_tag").show();
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    $(".filter_tag").hide();
                    delete Shopify.queryParams.constraint;
                }
              	
                miami.sidebarAjaxClick();
                e.preventDefault();
              
            });
        },

      	getCurrentTag: function() {
          	$(".tag_list").empty();
          	$(".product-filter .grid__item ul").each(function(index, element){              
               $('li',this).each(function(index, element) {                 
				  $("input:checkbox:checked", this).each(function(index, element) {
                 	var current_tag_val = $(this).val();   
                    var current_tag_name = $(this).next().text();
                	$(".tag_list").append("<span value='"+ current_tag_val +"'>"+ current_tag_name +"</span>" );
                  });
               });               
            });
            $(".tag_list").append(' <span class="clear_all"> Clear All </span>' );
          
            $(".tag_list span , .apply_filter").click(function(e) {  
             	var currentTags = [];
               	var remove_tag = $(this).attr("value");
                $(".product-filter .grid__item ul").each(function(index, element){              
                  $('li',this).each(function(index, element) {                 
                    $("input:checkbox:checked", this).each(function(index, element) {
                      var current_tag_val = $(this).val();

                      if(current_tag_val == remove_tag ){

                      }else{
                        currentTags.push($(this).val()); 
                      }
                    });
                  });                
                }); 
                if (currentTags.length) {
                  $(".filter_tag").show();
                  Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                  $(".filter_tag").hide();
                  delete Shopify.queryParams.constraint;
                }

                if($(this).hasClass('apply_filter')){
                  $(".filter-icon.active").trigger('click');
                }

              miami.sidebarAjaxClick(); 
              e.preventDefault();
            });          
        },
      
      	newsletter: function() {
            //===   NEASLETTER POPUP
            $(window).load(function(){
                setTimeout( function() {
                  var check_cookie = $.cookie('mailing_list_popup');
                  
                  $('.newsletter_popup .close_btn').click(function(e) {
                    $.cookie('mailing_list_popup', '1', { expires: 31 });
                    $(".newsletter_overlay").removeClass('newsletter_popupactive');
                    $('body').removeClass('overflow_hidden');
                  });
                  
                  if(check_cookie == null){
                    $.cookie('mailing_list_popup', '1', { expires: 31 });
                    $(".newsletter_overlay").addClass('newsletter_popupactive');
                    $('body').addClass('overflow_hidden');
                  }
                  else if(check_cookie < 1){
                    x = $.cookie('mailing_list_popup');
                    y = 1;
                    var z = +x + +y;
                    $.cookie('mailing_list_popup', z, { expires: 31 });
                      $(".newsletter_overlay").addClass('newsletter_popupactive');
                      $('body').addClass('overflow_hidden');
                  }
                }, 3000);
            }); 
        },
      	
        sidebarMapCategories: function() {
            $(".categories_view .sidebar-links a").click(function(e) {           	
                if (!$(this).hasClass('active')) {                	
                    delete Shopify.queryParams.q;
                    miami.sidebarAjaxClick($(this).attr('href'));

                    //activate selected category
                    $(".sidebar-links a.active").removeClass("active");
                    $(this).addClass("active");
                }
                e.preventDefault();
            });
        },

        sidebarMapSorting: function(e) {  
          $("#heapbox_sortby .heapOption a").click(function(){           
            Shopify.queryParams.sort_by = $(this).attr("rel"); 
            miami.sidebarAjaxClick();
          }); 
        },

        sidebarMapEvents: function() {
            miami.sidebarMapTagEvents();
           	miami.sidebarMapCategories();
            miami.sidebarMapSorting();
        },

        sidebarMapPaging: function() {
            $(".collection-filter .pagination a").click(function(e) {
                var page = $(this).attr("href").match(/page=\d+/g);
                if(page) {
                    Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
                    if (Shopify.queryParams.page) {
                        var newurl = miami.sidebarCreateUrl();
                        miami.isSidebarAjaxClick = true;
                        History.pushState({
                            param: Shopify.queryParams
                        }, newurl, newurl);
                        miami.sidebarGetContent(newurl);
                        //go to top
                        $('body,html').animate({
                            'scrollTop': 0
                        }, 500);
                    }
                }
                e.preventDefault();
            });
        },

        sidebarMapClearAll: function() {
            //clear all selection
             $('.clear_all').click(function(e) {
                delete Shopify.queryParams.constraint;
                delete Shopify.queryParams.q;                
              	miami.sidebarAjaxClick();
                e.preventDefault();   
                $('.product-filter').slideUp(200);
                $(".filter-icon").removeClass("active");
                $(".filter-options").removeClass("active");
               	$(".heapBox").show();
                
            });
        },

        sidebarMapClear: function() {            
            $(".product-filter .grid__item ul,.sidebar-tag").each(function() {
                var sidebarTag = $(this);
                if(sidebarTag.find("input:checked").length > 0) {
                    $('.clear_all').show();
                    //has active tag
                    sidebarTag.find(".clear").css("display","block").click(function(e) {
                        var currentTags = [];
                        if(Shopify.queryParams.constraint) {
                            currentTags = Shopify.queryParams.constraint.split('+');
                        }
                        sidebarTag.find("input:checked").each(function() {
                            var selectedTag = $(this);
                            var tagName = selectedTag.val();
                            if(tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        });
                        if(currentTags.length) {
                            Shopify.queryParams.constraint = currentTags.join('+');
                        } else {
                            delete Shopify.queryParams.constraint;
                        }
                        miami.sidebarAjaxClick();
                        e.preventDefault();
                    });
                }
            });
        },

        sidebarCreateUrl: function(baseLink) {        	
            var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
            if (baseLink) {
                //location.href = baseLink + "?" + newQuery;
                if (newQuery != "")
                    return baseLink + "?" + newQuery;
                else
                    return baseLink;
            }else{
            	if (newQuery != "")
	              return location.pathname + "?" + newQuery;
	            else
	              return location.pathname + newQuery;
            }
            //return location.pathname + "?" + newQuery;
        },

        sidebarAjaxClick: function(baseLink) {
            delete Shopify.queryParams.page;
            var newurl = miami.sidebarCreateUrl(baseLink); 
            miami.isSidebarAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, newurl, newurl);
            miami.sidebarGetContent(newurl);            
        },
      
        wishlist: function() {    
            //============wishlist ajax
            $(".wishlist_btn").click(function(e) {
              e.preventDefault();

              var form = $(this).parent();
              $.ajax({
                url : '/contact#contact_form',
                type: "POST",
                data : form.serializeArray(),
                success:function(data, textStatus) {              
                  alert("This product Added in your Wishlist"); 
                  var product =form.find(".wishlist").html();
                  if(product) {
                  	form.parent().empty().html('<a href="/pages/wishlist" class="wishlist">Added to wishlist</a>');
                  }
                  else {
                    form.parent().empty().html('<a href="/pages/wishlist"><i class="fa fa-heart"></i></a>');
                  }
                },
                error: function() {
                  $(this).append("<p>I'm afraid that didn't work.</p>");
                }
              });
            }); 
        },
                   
        sidebarGetContent: function(newurl) {
            $.ajax({
                type: 'get',
                url: newurl,
                beforeSend: function() {
                    miami.showLoading();
                },
                success: function(data) {  
                    miami.sidebarMapData(data);
                  	if ($(".product-filter").length > 0) {  
                      miami.getCurrentTag();
                      miami.sidebarMapTagEvents();
                      miami.sidebarMapCategories();
                      miami.sidebarMapClear();
                      miami.sidebarMapClearAll();
                    }
                  	miami.sidebarMapPaging();
                    setTimeout(function() {                      
                  		miami.grid_height();
                    }, 1000);
                    miami.wishlist();
                  	miami.sort_filter();
                  	//miami.sidebarMapSorting();
                    miami.hideLoading();   
                },
                error: function(xhr, text) {
                    miami.hideLoading();
                    $('.loading-modal').hide();
                    $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);                   
                }
            });
        },
      
		showLoading: function() {
            $('.loading-modal').show();
        },
      
      	hideLoading: function() {
            $('.loading-modal').hide();
        },

        scrolltop :function(){
            $('#scrollToTop').bind("click", function () {
              $('html, body').animate({ scrollTop: 0 }, 800);
              return false;
            });
          },
      
        sidebarMapData: function(data) {                       
            var currentList = $(".new_pro_list > .grid");
            if (currentList.length == 0) {
                currentList = $(".new_pro_list > .grid");
            }

            var productList = $(data).find(".new_pro_list > .grid");
            if (productList.length == 0) {
                productList = $(data).find(".new_pro_list > .grid");
            }
            currentList.replaceWith(productList);
           
            //replace paging 
            if ($(data).find(".pagination").length > 0) {
            	$(".collection-filter").show();
                $(".collection-filter").replaceWith($(data).find(".collection-filter"));
            }else{
            	$(".collection-filter").hide();
            }
          
          	
          	$(".wrapper-dropdown").replaceWith($(data).find(".wrapper-dropdown"));
			$(".apply_filter").replaceWith($(data).find(".apply_filter"));
            $(".mobileclear").replaceWith($(data).find(".mobileclear"));
          
            //replace sidbar            
            $(".product-filter .grid").replaceWith($(data).find(".product-filter .grid"));  
          
			width_screen = $(window).width();          
            if(width_screen < "991"){             
          		miami.widthResizeContent();                 
            }
        }
      
	}
    
     
          
 //=======================   DROPDOWN
$(".sortby").heapbox();

$( "#accordion" ).accordion({
    collapsible: true,
	heightStyle: "content"
});
      
      
$( ".search_box input" ).focus(function() {
  $('.search_overlay').addClass('search_effect');
});

$( ".search_box .close a" ).click(function() {
  $('.search_overlay').removeClass('search_effect');
});




